import { theme } from '@styles';

export const getStyles = isValid => ({
  '& .MuiInputBase-input': {
    padding: 0,
    fontSize: '16px',
    color: isValid ? theme.color.gray[500] : theme.color.red,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '0px !important',
  },
});
